<ng-template #editBranchModal role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="addNewBranch">Edit Branch</h5>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="mb-3">
        <label for="choices-single-default" class="form-label"
          >Admin Hierarchy <span class="required-star">*</span></label
        >
        <ng-select
          [items]="admin_hierarchy"
          formControlName="administrative_hierarchy_id"
          bindLabel="administrative_hierarchy_id"
          bindLabel="name"
          bindValue="id"
          placeholder="Admin Hierarchy"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        <small
          *ngIf="
            isSubmitted &&
            form.get('administrative_hierarchy_id')?.hasError('required')
          "
          class="text-danger m-0"
        >
          Admin Hierarchy is required
        </small>
      </div>

      <div class="mb-3">
        <label for="name" class="col-form-label"
          >Name <span class="required-star">*</span></label
        >
        <input
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Name"
          id="name"
          appMaxInputLimit
          [maxLength]="45"
        />
        <small
          *ngIf="isSubmitted && form.get('name')?.hasError('required')"
          class="text-danger m-0"
        >
          Branch name is required
        </small>
      </div>
      <div class="mb-3">
        <label for="name" class="col-form-label"
          >Code <span class="required-star">*</span></label
        >
        <input
          type="text"
          class="form-control"
          formControlName="branch_code"
          placeholder="branch_code"
          id="branch_code"
          appMaxInputLimit
          [maxLength]="155"
        />
        <small
          *ngIf="isSubmitted && form.get('branch_code')?.hasError('required')"
          class="text-danger m-0"
        >
          Branch code is required
        </small>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="modal.close('Close click')"
      >
        Close
      </button>
      <button type="submit" [disabled]="submittedData" class="btn btn-primary">
        <i *ngIf="submittedData" class="mdi mdi-spin mdi-dots-circle"></i>

        {{ submittedData == true ? "Please Wait..." : "Edit Branch" }}
      </button>
    </div>
  </form>
</ng-template>
